var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from "styled-components";
var LoadingSpinner = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #3498db;\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  min-width: ", ";\n  min-height: ", ";\n  max-width: ", ";\n  max-height: ", ";\n  animation: spin 2s linear infinite;\n  margin: 0;\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), function (props) {
  return props.width ? props.width : '30px';
}, function (props) {
  return props.height ? props.height : '30px';
}, function (props) {
  return props.width ? props.width : '30px';
}, function (props) {
  return props.height ? props.height : '30px';
}, function (props) {
  return props.width ? props.width : '30px';
}, function (props) {
  return props.height ? props.height : '30px';
});
export default LoadingSpinner;